module.exports = __webpack_public_path__ + "static/media/close.7d6d925d.svg";